import React, { useEffect, useState } from "react";
import "./projects.css";
import ProjectModal from "../../components/ProjectModal/ProjectModal";

function Projects() {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [filterStatus, setFilterStatus] = useState("All");
  const [usageCategory, setUsageCategory] = useState(null); // "Mimari", "Dekorasyon", "Çelik"

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // Fetch projects once on mount
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/projects`);
        if (!response.ok) throw new Error("Failed to fetch projects");
        const data = await response.json();
        setProjects(data);
      } catch (err) {
        console.error("Error fetching projects:", err);
      }
    };
    fetchProjects();
  }, []);

  const handleCardClick = (project) => setSelectedProject(project);
  const closeModal = () => setSelectedProject(null);

  // Filter projects by completion status and usage
  const filteredProjects = projects.filter((project) => {
    const matchesStatus =
      filterStatus === "All" || project.completionStatus === filterStatus;
    const matchesUsage =
      !usageCategory ||
      (Array.isArray(project.usage) && project.usage.includes(usageCategory));
    return matchesStatus && matchesUsage;
  });

  // Frontpage with usage selection
  if (!usageCategory) {
    return (
      <div className="frontpage-container">
        <h1 className="frontpage-title">PROJELERİMİZ</h1>
        <div className="frontpage-options">
          <div
            className="frontpage-card"
            onClick={() => setUsageCategory("Mimari")}
          >
            <img src="./assets/resimler/MimariArkaPlan.jpg" alt="Mimari" />
            <span>ERYA MİMARİ</span>
          </div>
          <div
            className="frontpage-card"
            onClick={() => setUsageCategory("Dekorasyon")}
          >
            <img src="./assets/resimler/DekorasyonArkaPlan.jpg" alt="Dekorasyon" />
            <span>ERYA DEKORASYON</span>
          </div>
          <div
            className="frontpage-card"
            onClick={() => setUsageCategory("Çelik")}
          >
            <img src="./assets/resimler/ÇelikArkaPlan.jpg" alt="Çelik" />
            <span>ERYA ÇELİK</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <h1 className="page-title">{usageCategory} Projelerimiz</h1>

      <div className="filter-buttons">
        <button
          className={filterStatus === "All" ? "active" : ""}
          onClick={() => setFilterStatus("All")}
        >
          Tümü
        </button>
        <button
          className={filterStatus === "Tamamlandı" ? "active" : ""}
          onClick={() => setFilterStatus("Tamamlandı")}
        >
          Tamamlanan Projelerimiz
        </button>
        <button
          className={filterStatus === "Tamamlanmadı" ? "active" : ""}
          onClick={() => setFilterStatus("Tamamlanmadı")}
        >
          Devam Eden Projelerimiz
        </button>
      </div>

      <div className="projects-container">
        {filteredProjects.map((project) => (
          <div
            className="project-card"
            key={project._id}
            onClick={() => handleCardClick(project)}
          >
            <div className="project-image-container">
              <div
                className="project-image"
                style={{
                  backgroundImage: `url(${
                    project.images && project.images[0] ? project.images[0] : ""
                  })`,
                }}
              ></div>
              <div className="project-title-overlay">{project.title}</div>
            </div>
          </div>
        ))}
      </div>

      {selectedProject && (
        <ProjectModal project={selectedProject} onClose={closeModal} />
      )}

      <button className="back-button" onClick={() => setUsageCategory(null)}>
        Kategori Ekranına Dön
      </button>
    </div>
  );
}

export default Projects;
